import React, { useEffect } from "react";
import DashboardDefault from "./DashboardDefault/DashboardDefault";
import DashboardEquity from "./Dashboard-Equity/DashboardEquity";
import { useState } from "react";
import Header from "../../Components/Header";
import Sidebar from "../../Components/Sidebar";
import { Constants } from "../../CommonMethhods/Constants";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";

function Dashboard(props) {
  const [renderEquity, setRenderEquity] = useState(false);
  const storeToken = localStorage.getItem("ssoToken");
  if (storeToken == null) {
    window.location.replace("/");
    // localStorage.clear("");
  }
  useEffect(() => {
    let mode = localStorage.getItem("darkmode");
    let element = document.body;
    if (mode === true) {
      element.classList.add("darkmode");
    }
  }, []);

  // >>>>>>> c25e623c6d95ee44f6a7eb7fba53fede2adff244
  return (
    <>
      <Header portal={"RM"} />
      <SingleSignOnSideBar />
      <main id="main-content">
        {/* <!-- Main tab Level 1 --> */}
        {/* <div className="card-tabs main-tabs">
          <div className="card-tab-list filter-tabs team-own-tab">
            <ul className="nav nav-tabs " id="mainTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link active"
                  id="team-tab"
                  data-toggle="tab"
                  data-target="#team"
                  type="button"
                  role="tab"
                  aria-controls="Team"
                  aria-selected="true"
                >
                  Team
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="own-tab"
                  data-toggle="tab"
                  data-target="#own"
                  type="button"
                  role="tab"
                  aria-controls="own"
                  aria-selected="false"
                >
                  Own
                </button>
              </li>
            </ul>
          </div>
        </div> */}
        {/* <div> */}
        {/* <div className="card-tab-details"> */}
        {/* <!-- Main tab Level 1 tab Content --> */}
        {/* <div className="tab-content" id="mainTabContent">
            <div
              className="tab-pane fade show active"
              id="team"
              role="tabpanel"
              aria-labelledby="team-tab"
            > */}
        {/* <!-- Main tab Level 2 --> */}
        {/* <div className="secondary-tabs">
                <div className="card-tab-list">
                  <ul className="nav page-tabs" id="mainTab" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link active"
                        id="default-tab"
                        data-toggle="tab"
                        data-target="#default"
                        type="button"
                        role="tab"
                        aria-controls="default"
                        aria-selected="true"
                      >
                        {Constants.Default}
                      </button>
                    </li> */}
        {/* <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="equity-tab"
                        data-toggle="tab"
                        data-target="#equity"
                        type="button"
                        role="tab"
                        aria-controls="equity"
                        aria-selected="false"
                        onClick={() => setRenderEquity(true)}
                      >
                        {Constants.Equity}
                      </button>
                    </li> */}
        {/* <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="mutual-tab"
                        data-toggle="tab"
                        data-target="#mutual"
                        type="button"
                        role="tab"
                        aria-controls="mutual-tab"
                        aria-selected="false"
                      >
                        Mutual Funds
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="insurance-tab"
                        data-toggle="tab"
                        data-target="#insurance"
                        type="button"
                        role="tab"
                        aria-controls="insurance"
                        aria-selected="false"
                      >
                        Insurance
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="fd-tab"
                        data-toggle="tab"
                        data-target="#fd"
                        type="button"
                        role="tab"
                        aria-controls="fd"
                        aria-selected="false"
                      >
                        Corporate FD
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="bonds-tab"
                        data-toggle="tab"
                        data-target="#bonds"
                        type="button"
                        role="tab"
                        aria-controls="bonds"
                        aria-selected="false"
                      >
                        Bonds
                      </button>
                    </li> */}
        {/* </ul>
                </div>
                <div className="card-tab-details"> */}
        {/* <!-- Main tab Level 2 tab Content --> */}
        {/* <div
                    className="tab-content dashboard-tab-content"
                    id="secondaryTabContent"
                  > */}
        {/* <!-- Default Tab Content Start --> */}
        {/* <DashboardDefault /> */}
        {/* <!-- Default Tab Content End --> */}

        {/* <!-- Equity Tab Content Start --> */}
        {/* {renderEquity && <DashboardEquity />} */}
        {/* <!-- Equity Tab Content End--> */}
        {/* </div>
                </div>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="own"
              role="tabpanel"
              aria-labelledby="own-tab"
            >
              {Constants.OwnPage}
            </div>
          </div>
        </div> */}
        <DashboardDefault />
        {/* </div> */}
      </main>
    </>
  );
}

export default Dashboard;
